import { render } from "./swoutCredito.vue?vue&type=template&id=ba4063cc&scoped=true"
import script from "./swoutCredito.vue?vue&type=script&lang=js"
export * from "./swoutCredito.vue?vue&type=script&lang=js"

import "./swoutCredito.vue?vue&type=style&index=0&id=ba4063cc&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4063cc"]])

export default __exports__